/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/MvvmStructure/Service/NewsService',['pixi', 'Solitaire/MvvmStructure/Service/ManifestService'], function (PIXI, ManifestService) {
    "use strict";

    var NewsService = {

        _cache: null,

        LoadJsonFromCDN: function (url, onSuccess, onError) {
            var loader = new PIXI.JsonLoader(url, true /* cross origin */);

            function onLoaded() {
                loader.removeEventListener('loaded', onLoaded);
                loader.removeEventListener('error', onError);
                onSuccess(loader.json);
            }

            function onFailed(error) {
                loader.removeEventListener('loaded', onLoaded);
                loader.removeEventListener('error', onError);
                onError();
            }

            loader.addEventListener('loaded', onLoaded);
            loader.addEventListener('error', onFailed);

            loader.load();
        },


        LoadDataFromCDN: function (onSuccess, onError) {
            var settingsData = ManifestService.GetSettings("News", "Defaulthtml");

            if (!settingsData || !settingsData.Path) {
                onError();
            }
            else {
                this.LoadJsonFromCDN(settingsData.Path, onSuccess, onError);
            }
        },

        GetLatestNews: function (onSuccess, onError) {
            if (this._cache) {
                setTimeout(function () { onSuccess(this._cache)}.bind(this), 0);
            }
            else {
                this.LoadDataFromCDN(
                    function (data) {
                        this._cache = data;
                        onSuccess(this._cache);
                    }.bind(this),
                    onError);
            }
        }
    };


    return NewsService;

});
